import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, renderSlot as _renderSlot } from "vue"

const _hoisted_1 = { class: "dropdown position-relative" }
const _hoisted_2 = {
  key: 0,
  class: "filter-badge position-absolute bg-primary rounded-circle"
}
const _hoisted_3 = { class: "dropdown-menu p-4" }

import { provide, ref } from "vue";

export default /*@__PURE__*/_defineComponent({
  __name: 'TableFilter',
  setup(__props) {

const hasFiltersSelected = ref(false);

const setHasFilterSelected = (hasSelected: boolean) => {
  hasFiltersSelected.value = hasSelected;
};

provide("TableFilter", {
  setHasFilterSelected,
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (hasFiltersSelected.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2))
      : _createCommentVNode("", true),
    _cache[0] || (_cache[0] = _createElementVNode("button", {
      class: "btn btn-link text-body-secondary dropdown-toggle d-flex",
      type: "button",
      "data-bs-toggle": "dropdown",
      "aria-expanded": "false"
    }, [
      _createElementVNode("i", { class: "fas fa-sliders-h fs-3" })
    ], -1)),
    _createElementVNode("div", _hoisted_3, [
      _renderSlot(_ctx.$slots, "default")
    ])
  ]))
}
}

})